export default "__VITE_ASSET__984a0d8b__"